import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=338b8efc&"
import script from "./DefaultForm.vue?vue&type=script&lang=js&"
export * from "./DefaultForm.vue?vue&type=script&lang=js&"
import style0 from "./DefaultForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports